export const config = {
    appname: 'Chanel',
    client_id: '630828704422456', // App ID
    facebook_app_id: '630828704422456', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    agency_id: '',
    sponsor_id: '197696',
    bzbsUrl: 'https://apichl2.buzzebees.com',
    bzbsAddItemFromList: 'https://apichl2.buzzebees.com/cart/',
    // bzbsBlobUrl: 'https://buzzebees.blob.core.windows.net',
    bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    bzbsShoppingCartUrl: 'https://cartchl.buzzebees.com',
    bzbsAddItem: 'https://cartchl.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://cartchl.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://www.buzzebees.com',
    bzbsPointExpire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1655087978-2YNa9eko',
    liffIdPointPrd: '1655087978-Y4a1x8KN',
    urlPoingPrd: 'prd-web-chanel-staging.azurewebsites.net',
    lineVersion: '2.6.0',
    linkSupport: 'https://line.me/R/ti/p/@223nmess',
    // ------------------ End Settings ---------------------


    // ------------- Development New Settings ----------------
    newApi: 'apichl2',
    newBzbsUrl: 'https://apichl2.buzzebees.com',
    newBzbsModuleUrl: 'https://chanelmodule.buzzebees.com',
    newApiShoppingCartUrl: 'https://shoppingcartmodule12.buzzebees.com',
    newWebShoppingCartUrl: 'https://shoppingcartservice12.buzzebees.com',
    siteKey: '6LdCPYsqAAAAAFC212hrSM1fexVg8haFgcHrT7b8',
    secretKey: '6LdCPYsqAAAAAOZJAOx07NG-Y_oYgBTtP3Us2jW_',

    // ------------------ End new Settings ---------------------

    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    mainConfig: {
    },
    firebase: {
        apiKey: "AIzaSyBi1Ly-ufija-7p0TbwaTr3vp3G66dKK6w",
        authDomain: "chanel-production.firebaseapp.com",
        databaseURL: "https://chanel-production.firebaseio.com",
        projectId: "chanel-production",
        storageBucket: "chanel-production.appspot.com",
        messagingSenderId: "725828698399",
        appId: "1:725828698399:web:871c6b65dbfa516693b02a",
        measurementId: "G-N7KPL64GHE"
    },
};
